import React from 'react';

import {PollingAnalysisTemplate} from 'analysis-tool/polling/PollingPipeline';
import AnalysisClientStateIdContext from 'analysis-tool/ui/AnalysisClientStateIdContext';
import {PresentationalAnalysisUISkeleton} from 'analysis-tool/ui/AnalysisUISkeleton';

export interface EditableAnalysisTemplatePageProps {
  analysisTemplateId: string;
}

export default function EditableAnalysisTemplatePage({
  analysisTemplateId,
}: EditableAnalysisTemplatePageProps): JSX.Element {
  return (
    <AnalysisClientStateIdContext.Provider value={analysisTemplateId}>
      <PollingAnalysisTemplate analysisTemplateId={analysisTemplateId}>
        {(analysisTemplate) => (
          <PresentationalAnalysisUISkeleton clientStateId={analysisTemplateId} analysis={analysisTemplate} />
        )}
      </PollingAnalysisTemplate>
    </AnalysisClientStateIdContext.Provider>
  );
}
